import OpenAI from "openai";

export async function searchEventsWithAI({ country, state }) {
    const apiKey = import.meta.env.VITE_OPENAI_API_KEY;

    if (!apiKey) {
        throw new Error("[OpenAI] Missing API key. Add VITE_OPENAI_API_KEY to .env.local");
    }

    const openai = new OpenAI({
        apiKey,
        // Required in browser – but risky, keep an eye on exposure
        dangerouslyAllowBrowser: true,
    });

    const prompt = `
    Find current upcoming gay party events in ${state}, ${country} happening this month.
    Return the data as an array of JSON objects with fields:
    id, created, name, country, state, city, venue, eventUrl, ticketsUrl, type, startDatetime, lastUpdatedDatetime.
    If you can't find events, say "none found".
  `;

    const chat = await openai.chat.completions.create({
        model: "gpt-4o-mini", // cheaper + faster; upgrade if needed
        messages: [{ role: "user", content: prompt }],
    });

    const raw = chat.choices[0]?.message?.content ?? "";
    try {
        return JSON.parse(raw);
    } catch {
        console.warn("Could not parse response as JSON, returning raw text.");
        return { raw };
    }
}
